export interface UseEmailTrackingReturn {
  trackLeadForEmail: (email: string, hashedEmail: string) => Promise<void>;
  trackPaymentEmailRetrieved: (email: string) => Promise<void>;
}

export function useEmailTracking(): UseEmailTrackingReturn {
  const { pixelAddUserData } = useFacebookPixel();
  const { setUserProperty } = useMixpanel();
  const store = useKegelAnalyticStore();
  const { $paymentMethods, $ttIdentify } = useNuxtApp();
  const { track } = useEventsDispatcher();

  async function trackLeadForEmail(email: string, hashedEmail: string): Promise<void> {
    pixelAddUserData({ em: hashedEmail });
    $ttIdentify?.({ email });
    if (store.userEmail) {
      setUserProperty({ $email: email });
    }
  }

  async function trackPaymentEmailRetrieved(email: string): Promise<void> {
    const hashed = store.sha256UserEmail;
    if (hashed) {
      pixelAddUserData({ em: hashed });
      $ttIdentify?.({ email });
    }
    track('Payment Email Retrieved', {
      payment_method: $paymentMethods?.paypal,
      email_attached: !!email,
      email,
    });
    if (email) {
      setUserProperty({ $email: email });
    }
  }

  return {
    trackLeadForEmail,
    trackPaymentEmailRetrieved,
  };
}
